module.exports = __webpack_public_path__ + "static/img/logo-login.abf99b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-login.png
// module id = 211
// module chunks = 1